import React from 'react';
import { useLanguage } from '../locale/useLanguage';
import { WarningIcon } from './index';

interface AnonymousWarningBannerProps {
  className?: string;
}

const AnonymousWarningBanner: React.FC<AnonymousWarningBannerProps> = ({
  className = '',
}) => {
  const [t] = useLanguage();

  return (
    <div
      className={`mt-6 bg-yellow-50 border border-yellow-400 rounded-md p-4 mb-6 ${className}`}
      style={{ backgroundColor: '#fef3c7', borderColor: '#f59e0b' }}
    >
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <WarningIcon
            className="h-5 w-5"
            style={{ color: '#f59e0b' }}
          />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium" style={{ color: '#92400e' }}>
            {t('dashboard.analytics.tooManyAnonymousFeedbacks')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnonymousWarningBanner;
